const allRegsModel = require.context("@/pages", true, /Reg\.js$/);
let allRegs = allRegsModel.keys().map(item => allRegsModel(item).default);

let filterRegs = allRegs.filter(item=>item.meta?.show)

const routes = [
   ...filterRegs
  ] 
  export default routes